import type { ButtonType } from 'antd/es/button'

import type { ButtonVariant } from './types'

export const VARIANT_TO_ANT_TYPE: Record<ButtonVariant, ButtonType> = {
  primary: 'primary',
  secondary: 'default',
  tertiary: 'default',
  outline: 'default',
  link: 'link',
  'link-secondary': 'text',
  dashed: 'dashed'
}

export const ANT_SIZE_MAP = {
  large: 'large',
  default: 'middle',
  small: 'small'
} as const
